"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnquiryFormFieldIDs;
(function (EnquiryFormFieldIDs) {
    EnquiryFormFieldIDs["IDENTIFICATION_NUMBER_OF_DOCUMENT_TYPE"] = "root_identificationNumberByType_identificationNumber";
})(EnquiryFormFieldIDs = exports.EnquiryFormFieldIDs || (exports.EnquiryFormFieldIDs = {}));
